var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hiddenInput),expression:"!hiddenInput"}],ref:"fileUpload",attrs:{"type":"file","name":"fileUpload","accept":_vm.accept},on:{"change":_vm.onFileChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }